import { SxProps } from '@mui/material'

export default {
  section: ({
    withLightBackground,
    reverseContent,
  }: {
    withLightBackground?: boolean
    reverseContent?: boolean
  }) => ({
    display: 'flex',
    flexDirection: { xs: 'column', sm: reverseContent ? 'row-reverse' : 'row' },
    gap: 6,
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: { xs: '16px 0', sm: 6, xl: '48px 200px' },
    backgroundColor: withLightBackground ? '#FEF8F3' : '#FBF5F1',
  }),
  imgContainer: {
    display: { xs: 'block', sm: 'flex' },
    flexDirection: 'column',
    maxWidth: 445,
    height: 'fit-content',
  },
  img: ({ reverseContent }: { reverseContent?: boolean }) => ({
    display: { xs: 'block', sm: 'block' },
    alignSelf: reverseContent ? 'flex-end' : 'flex-start',
    width: '80%',
    height: 'auto',
    margin: { xs: '0 auto', sm: 'unset' },
    textAlign: 'center',
  }),
  secondaryImgContainer: ({ reverseContent }: { reverseContent?: boolean }) => ({
    display: { xs: 'none', sm: 'block' },
    alignSelf: reverseContent ? 'flex-start' : 'flex-end',
    maxWidth: 175,
    width: '42%',
    marginTop: '-3rem',
    padding: 0.5,
    backgroundColor: '#FFFFFF',
    boxShadow: '1px 1px 15px 1px rgba(0, 0, 0, 0.2)',
    transform: 'translate(0, 5%)',
  }),
  secondaryImg: {
    width: '100%',
    height: 'auto',
  },
} satisfies SxProps
